import { MapCardProps } from './MapCard'
import { Spacer } from '@/components/elements/Spacer'

export const cpMapList: Array<MapCardProps> = [
  {
    cpName: 'Head Office',
    cpSubName:
      'TRIAL Holdings, Inc. / TRIAL Company, Inc.',
    cpAddress: '1-12-2, Tanotsu, Higashi-ku, Fukuoka, 813-0034, Japan',
    addressUrl:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3322.2118348495715!2d130.448264!3d33.625749!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xfe465403033e9c51!2z5qCq5byP5Lya56S-44OI44Op44Kk44Ki44Or44Kr44Oz44OR44OL44O8!5e0!3m2!1sen!2sjp!4v1637135606813!5m2!1sen!2sjp',
    children: (
      <>
        <Spacer h={{ sp: 40, pc: 42 }} />
        <h4>[Public Transport]</h4>
        <Spacer h={{ sp: 36, pc: 30 }} />
        <h5>By Bus</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>
          From Hakata (Hakata Station Bus Terminal), please take bus number 73 bound for &quot;Doi Bus Office&quot;, &quot;Doi Danchi&quot;,
          or &quot;Midorigaoka Danchi Iriguchi&quot; at platform 14. Get off at “Oroseum FUKUOKA (Former Wholesale Kaikan-mae)”
          and walk for 2 to 3 minutes.
        </p>
        <Spacer h={{ sp: 42, pc: 45 }} />
        <h5>By Train</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>
          After leaving JR Hakozaki Station, take bus number 78 bound for &quot;Doi Danchi&quot; or &quot;Midorigaoka Danchi Iriguchi&quot; from the Hakozaki Station West Exit bus stop. Get off at &quot;Oroseum FUKUOKA (Former wholesale hall)&quot; and walk for 2 to 3 minutes. <br />
          After leaving JR Chihaya Station and take bus number 3 bound for &quot;Doi Bus Office&quot; from the Chihaya Ekimae bus stop. Get off at “Oroseum FUKUOKA (Former Wholesale Kaikan-mae)” and walk for 2 to 3 minutes.
        </p>
        <Spacer h={{ sp: 30, pc: 83 }} />
      </>
    ),
  },
  {
    cpName: 'Tokyo Head Office',
    cpSubName:
      'TRIAL Holdings, Inc. / TRIAL Company, Inc.',
    cpAddress: 'Sumitomo Fudosan Tamachi Building East 5F (Reception), 3-16-16, Shibaura, Minato-ku, Tokyo 108-0023, Japan',
    addressUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.4283164152293!2d139.7465946762298!3d35.641817532137466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188baedb024a65%3A0x47684ad20e4e676d!2sSumitomo%20Fudosan%20Tamachi%20Bldg.%20Higashikan!5e0!3m2!1szh-CN!2sjp!4v1773992257009!5m2!1sen!2sjp',
    children: (
      <>
        <Spacer h={{ sp: 40, pc: 42 }} />
        <h4>[Public Transport]</h4>
        <Spacer h={{ sp: 36, pc: 38 }} />
        <p>
          8 mins walk from the Shibaura Exit of JR Tamachi Station.
        </p>
        <p>
          10 mins walk from the A4 Exit of Mita Station on the Toei Asakusa Line / Mita Line.
        </p>
        <Spacer h={{ sp: 30, pc: 83 }} />
      </>
    ),
  },
  {
    cpName: 'MUSUBU AI',
    cpAddress: '394 Wakita, Miyawaka City, Fukuoka, 822-0133, JAPAN',
    addressUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3319.436704756755!2d130.58937415126087!3d33.697647080609194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35422b313d65e311%3A0x31f30c72bdb6e149!2sMUSUBU%20AI!5e0!3m2!1sen!2sjp!4v1675659119658!5m2!1sen!2sjp',
    children: (
      <>
        <Spacer h={{ sp: 40, pc: 42 }} />
        <h4>[Traffic access]</h4>
        <Spacer h={{ sp: 36, pc: 30 }} />
        <h5>By car</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>Approximately 50 minutes by car from Fukuoka Airport.</p>
        <Spacer h={{ sp: 42, pc: 45 }} />
        <h5>By bus</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>
          JR Kyushu Bus: 1 minute walk from bus stop No. 33 on the 3rd floor of Hakata Bus Terminal,
          bound for Yamanokami / Nogata, get off at &quot;Yoshikawa School Mae&quot;.
        </p>
        <Spacer h={{ sp: 30, pc: 83 }} />
      </>
    ),
  },
  {
    cpName: 'TRIAL IoT Lab',
    cpAddress: '9 Serita, Miyawaka City, Fukuoka 823-0013, JAPAN',
    addressUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3317.948164801104!2d130.63934125126173!3d33.73615648059844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3543d51fc82207b7%3A0xcae303a2ae31b067!2sTRIAL%20IoT%20Lab!5e0!3m2!1sen!2sjp!4v1675659770154!5m2!1sen!2sjp&hl=en',
    children: (
      <>
        <Spacer h={{ sp: 40, pc: 42 }} />
        <h4>[Traffic access]</h4>
        <Spacer h={{ sp: 36, pc: 30 }} />
        <h5>By car</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>Approximately 60 minutes by car from Fukuoka Airport.</p>
        <Spacer h={{ sp: 42, pc: 45 }} />
        <h5>By bus</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>
          JR Kyushu Bus: From bus stop 33 on the 3rd floor of Hakata Bus Terminal, get off at &quot;Chikuzen Serita&quot;
          bound for Yamanokami / Nogata and walk 5 minutes.
        </p>
        <Spacer h={{ sp: 30, pc: 83 }} />
      </>
    ),
  },
]
